"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTABILITY_METRIC_CHANNEL = exports.SUPPORTABILITY_METRIC = exports.FEATURE_NAME = exports.CUSTOM_METRIC_CHANNEL = exports.CUSTOM_METRIC = void 0;
var _features = require("../../loaders/features/features");
// import { ADD_EVENT_LISTENER_TAG } from '../../common/wrap/wrap-websocket'

const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.metrics;
const SUPPORTABILITY_METRIC = exports.SUPPORTABILITY_METRIC = 'sm';
const CUSTOM_METRIC = exports.CUSTOM_METRIC = 'cm';
const SUPPORTABILITY_METRIC_CHANNEL = exports.SUPPORTABILITY_METRIC_CHANNEL = 'storeSupportabilityMetrics';
const CUSTOM_METRIC_CHANNEL = exports.CUSTOM_METRIC_CHANNEL = 'storeEventMetrics';

// export const WATCHABLE_WEB_SOCKET_EVENTS = ['new', 'send', 'close', ADD_EVENT_LISTENER_TAG]